import { useState, useEffect } from 'react';
import './machine_css.css';
import NaviBar from './NaviBar/NaviBar';
import HomeProduct from './homeProduct/homeProduct';
import SearchBar from './NaviBar/SearchBar';
import HomeBrand from './homeProduct/HomeBrand';
import HomeCate from './homeProduct/HomeCategory';
import BottomCard from './ShoppingCart/BottomCart';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HomeStyleCategory from './Category/HomeStyleCate';
import HomeStyleBrand from './Category/HomeStyleBrand';

function Home(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const machine = JSON.parse(localStorage.getItem('machine'));

  const [homestyle, setHomeStyle] = useState(
    localStorage.getItem('homestyle') === 'false' ? false : true
  );

  // const scroll = (scrollOffset) => {
  //   ref.current.scrollLeft += scrollOffset;
  // };

  // console.log('machinetheme', machine?.themeColor);
  const {
    products,
    cleanUp,
    cart,
    setLoading,
    prods,
    add,
    decreStock,
    changeProdPrice,
    alterquantity,
    itemCounter,
    langs,
    remove,
    setShowCart,
    showCart,
    setlangs,
    themeColor,
    stat,
    setStat,
    changePrice,
    promoRef,
    audio,
    stopPlay,
    HFuser,
    clientUser,
    setClientUser,
  } = props;

  const goToALLProducts = (fridge) => {
    const isFridgeOrLockerEnabled =
      localStorage.getItem('ENABLE_FRIDGE') === 'TRUE' ||
      localStorage.getItem('ENABLE_LOCKER') === 'TRUE';

    if (!isFridgeOrLockerEnabled) {
      return history.push(`/machineUI/category/cate/all/all`);
    }

    const fridgeRoutes = {
      '1': '/machineUI/category/cate/fridge1/all',
      '2': '/machineUI/category/cate/fridge2/all',
      '3': '/machineUI/category/cate/fridge3/all',
    };

    const route = fridgeRoutes[fridge] || '/machineUI/category/cate/bestSellers/all';
    history.push(route);
  };

  useEffect(() => {
    localStorage.setItem('homestyle', homestyle);
    console.log('homestyle', localStorage.getItem('homestyle'));
  }, [homestyle]);

  const renderFridgeSection = (fridge) => {
    const isFridgeEnabled = localStorage.getItem('ENABLE_FRIDGE') === 'TRUE';
    const isLockerEnabled = localStorage.getItem('ENABLE_LOCKER') === 'TRUE';
    const showFridgeProduct = isFridgeEnabled || (isLockerEnabled && fridge === '3');

    if (showFridgeProduct) {
      return (
        <div>
          <HomeProduct
            clientUser={clientUser}
            prods={prods}
            langs={langs}
            cart={cart}
            add={add}
            decreStock={decreStock}
            alterquantity={alterquantity}
            remove={remove}
            isLocal={isLocal}
            fridge={fridge}
          />
          <div
            className="view-more-button"
            style={{ marginTop: '-20px' }}
            onClick={() => goToALLProducts(fridge)}
          >
            {t('VIEW MORE')}
          </div>
        </div>
      );
    }

    if (fridge === '1' && machine?.themeColor?.b_column && machine?.themeColor?.b_column !== '0') {
      return <HomeBrand prods={prods} langs={langs} isLocal={isLocal} />;
    }

    if (fridge !== '1' && machine?.themeColor?.c_column && machine?.themeColor?.c_column !== '0') {
      return <HomeCate prods={prods} langs={langs} isLocal={isLocal} />;
    }

    return null;
  };

  const renderStyleLayout = () => {
    const StyleComponent = homestyle ? HomeStyleCategory : HomeStyleBrand;
    return (
      <StyleComponent
        langs={langs}
        stat={stat}
        setStat={setStat}
        setHomeStyle={setHomeStyle}
        homestyle={homestyle}
      />
    );
  };

  const renderDefaultLayout = () => {
    const isFridgeEnabled = localStorage.getItem('ENABLE_FRIDGE') === 'TRUE';
    const hideBbs = machine?.themeColor?.hide_bbs === 'true';

    return (
      <div className="home-container">
        {!hideBbs && (
          <div>
            <HomeProduct
              clientUser={clientUser}
              prods={prods}
              langs={langs}
              cart={cart}
              add={add}
              decreStock={decreStock}
              alterquantity={alterquantity}
              remove={remove}
              isLocal={isLocal}
            />
            <div
              className="view-more-button"
              style={isFridgeEnabled ? { marginTop: '-20px' } : {}}
              onClick={goToALLProducts}
            >
              {t('VIEW MORE')}
            </div>
          </div>
        )}

        <div>
          {renderFridgeSection('1')}
          {renderFridgeSection('2')}
          {renderFridgeSection('3')}
        </div>

        {hideBbs && (
          <div className="hide-bbs-view-all-div">
            <div className="view-more-button hide-bbs-view-all-button" onClick={goToALLProducts}>
              {t('VIEW ALL PRODUCTS')}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderMainContent = () => {
    const isStyleLayout = machine?.themeColor?.c_column === '2' || machine?.themeColor?.c_column === '3';
    return isStyleLayout ? renderStyleLayout() : renderDefaultLayout();
  };

  return (
    <div className="main-container">
      <div className="Navi"></div>
      <NaviBar
        products={products}
        cleanUp={cleanUp}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        setShowCart={setShowCart}
        setlangs={setlangs}
        cart={cart}
        langs={langs}
        setLoading={setLoading}
        clientUser={clientUser}
        setClientUser={setClientUser}
      />
      <SearchBar langs={langs} themeColor={themeColor} />
      {renderMainContent()}

      <BottomCard
        cleanUp={cleanUp}
        setClientUser={setClientUser}
        clientUser={clientUser}
        HFuser={HFuser}
        promoRef={promoRef}
        changePrice={changePrice}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={prods}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        isLocal={isLocal}
        audio={audio}
        stopPlay={stopPlay}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default Home;
